<template>
  <q-card v-if="order">
    <q-card-section>
      <div class="text-h6">
        Состав заказа
      </div>

      <Table
        table-id="PageOrdersDetailsTable"
        :table-config="tableConfig"
        :table-data="order.orderList"
        :current-page="page"
        :pages="totalPages"
      />
    </q-card-section>
    <q-card-section>
      <div class="text-h6">
        Детали заказа
      </div>
      <br>
      <div><strong>Номер заказа:</strong> {{ order.orderNumber }}</div>
      <br>
      <div><strong>Дата создания заказа:</strong> {{ order.orderCreatedAtDate }}</div>
      <br>
      <div><strong>Время создания заказа:</strong> {{ order.orderCreatedAtTime }}</div>
      <br>
      <div><strong>Стоимость заказа:</strong> {{ order.orderCost }}</div>
      <br>
      <div><strong>Статус заказа:</strong> {{ order.orderStatus }}</div>
      <br>
      <div><strong>Статус оплаты заказа:</strong> {{ order.orderPaymentStatus }}</div>
      <br>
      <div><strong>Статус доставки заказа:</strong> {{ order.orderDeliveryStatus }}</div>
      <br>
      <div><strong>ФИО сборщика заказа:</strong> {{ order.orderCollectorFullName }}</div>
      <br>
      <div><strong>Адрес точки А:</strong> {{ order.addressFrom }}</div>
      <br>
      <div><strong>Номер магазина:</strong> {{ order.shopNumber }}</div>
      <br>
      <div><strong>Адрес точки B:</strong> {{ order.addressTo }}</div>
      <br>
      <div><strong>Комментарий к заказу от клиента:</strong> {{ order.commentFromClient }}</div>
      <br>
      <div><strong>“Бесконтактная доставка”:</strong> {{ order.contactlessDelivery }}</div>
      <br>
      <div><strong>ФИО клиента, оформившего заказ:</strong> {{ order.customerFullName }}</div>
      <br>
      <div><strong>Название курьерской службы:</strong> {{ order.courierServiceName }}</div>
      <br>
      <div><strong>ФИО курьера:</strong> {{ order.courierFullName }}</div>
      <br>
      <div><strong>Телефон курьера:</strong> {{ order.courierPhone }}</div>
    </q-card-section>
  </q-card>
</template>

<script>
/**
 * Карточка деталей заказа
 * @module PageOrders/Component/OrderDetails
 * @requires Shared/Component/Table
 * @requires PageOrders/orderDetailsTableConfig
 * @requires npm:vuex
 * @vur-data {Array.<Object>} tableConfig
 * @vur-prop {Object} order
 * */
import Table from 'Shared/Table'
import tableConfig from 'PageOrders/orderDetailsTableConfig'
import { mapState } from 'vuex'

export default {
  components: {
    Table
  },
  props: {
    order: Object
  },
  data: () => ({
    tableConfig
  }),
  computed: {
    ...mapState(['orders', 'page', 'totalPages'])
  }
}
</script>
